import {
  Button,
  Card,
  Switch,
  Table,
  Tooltip,
  Form,
  Input,
  Modal,
  Row,
  Col,
  DatePicker,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { useLocation, useNavigate, useParams } from "react-router";
import { APIServices } from "../../services/AuthAPIs";

const { RangePicker } = DatePicker;

function Index() {
  const heading = lang("Feed") + " " + lang("Manager");
  const { setPageHeading } = useContext(AppStateContext);
  const Search = Input.Search;
  const sectionName = lang("Feed");
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");
  const { getData, deleteData } = APIServices();

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const feedDetails = location.state.data;
  const params = useParams();

  const columns = [
    {
      title: "Comment",
      dataIndex: "description",
      key: "description",
      width: 200,
      sorter: (a, b) => a?.description?.localeCompare(b?.description),
      render: (_, { description }) => {
        return description ? description : "-";
      },
    },
    {
      title: "Comment By",
      // sorter: (a, b) => a.mobile_number?.localeCompare(b.mobile_number),
      render: (_, { user_id }) => {
        return user_id ? (
          <div className="posed-by_--emaill">
            <p>{user_id?.name}</p>
            <p>{user_id?.email}</p>
          </div>
        ) : (
          "-"
        );
      },
    },
    {
      title: "liked by",
      sorter: (a, b) => (a?.liked_by?.length || 0) - (b.liked_by?.length || 0),
      render: (_, { liked_by }) => {
        return liked_by?.length ? liked_by?.length : "0";
      },
    },
    {
      title: "Is Flagged",
      render: (_, { is_flagged }) => {
        return is_flagged ? "Yes" : "No";
      },
    },
    {
      title: "Commented On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i
                  style={{ fontSize: "small", color: "fff" }}
                  class="fa fa-light fa-trash"
                ></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null;

    request({
      url:
        apiPath.getFeedcomments +
        `/${params.id}?status=${
          filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&pageSize=${
          pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${
          startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}${path ? `&status=1` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(data.data);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          total: data?.total,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    if (!params.id) return;
    fetchData({ ...pagination, current: 1 });
  }, [params.id, refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };
  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: 10 });
  };

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col span={24} className="mb-3">
            <Card>
              <div className="view-main-list">
                <div className="view-inner-cls">
                  <h5>User:</h5>
                  <h6>
                    <div className="posed-by_--emaill cap">
                      <h6 className="mb-1"> {feedDetails?.user_id?.name}</h6>
                      <h6> {feedDetails?.user_id?.email}</h6>
                    </div>
                  </h6>
                </div>
                <div className="view-inner-cls">
                  <h5>Caption:</h5>
                  <h6>{feedDetails?.caption ? feedDetails?.caption : "-"}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Location:</h5>
                  <h6>{feedDetails?.location ? feedDetails?.location : "-"}</h6>
                </div>

                {feedDetails?.tags?.length ? (
                  <div className="view-inner-cls">
                    <h5>Tags:</h5>
                    <h6>
                      {feedDetails?.tags?.map((itm) => itm.name).join(", ")}
                    </h6>
                  </div>
                ) : (
                  ""
                )}
                {feedDetails?.created_at ? (
                  <div className="view-inner-cls">
                    <h5>Posted On:</h5>
                    <h6>{moment(feedDetails?.created_at).format("ll")}</h6>
                  </div>
                ) : (
                  ""
                )}
                <div className="view-inner-cls">
                  <h5>Likes:</h5>
                  <h6>
                    {feedDetails?.likes?.length
                      ? feedDetails?.likes?.length
                      : 0}
                  </h6>
                </div>
                <div className="view-inner-cls">
                  <h5>Comments:</h5>
                  <h6>
                    {feedDetails?.comments?.length
                      ? feedDetails?.comments?.length
                      : 0}
                  </h6>
                </div>
              </div>
            </Card>
          </Col>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"Feed Comments"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    <Search
                      allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Comment, Post By"
                      title="Search By Comment, Post By"
                    />
                    <RangePicker
                      disabledDate={(current) => current.isAfter(Date.now())}
                      onChange={handleChangeDate}
                    />
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {showDelete && (
        <DeleteModal
          title={lang("Delete Feed Comment")}
          subtitle={lang(`Are you sure you want to delete this feed Comment?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() =>
            deleteData(
              apiPath.deleteFeedComment,
              selected?._id,
              setLoading,
              setRefresh
            )
          }
        />
      )}
    </>
  );
}

export default Index;
